import { bindActionCreators } from 'redux';
import React, { Component} from 'react';
import { connect } from 'react-redux';
import Header from '../layout/Header';
import { Link } from 'react-router';
import Translate from '../layout/Translate';
import Helmet from "react-helmet";
import * as toursActions from '../../actions/tours';



export default class TypeContent extends Component {

    componentWillMount() {

    }

    componentDidMount() {



    }

    componentDidUpdate() {

    }


    componentWillUnmount() {
        this.props.toursActions.setMapConfig({
            listByMap: false
        });
    }

    toggleFeedback() {
        this.props.actions.toggleFeedback();
    }
    
    
    render () {

        const type = this.props.type;
        const {seo, translations} = this.props;


        let meta = [
            {"name": "description", "content": (seo.description)?seo.description:translations["tour-type__description_" + type]}
        ];

        return (

            <div>
                <Helmet
                    title={(seo.title)?seo.title: (type + "nature").toUpperCase()}
                    meta={meta}
                />

                <div className="types__container">
                    <ul className="types types_menu">
                        <li className={"types__item types__item_menu types__item_active" + ((type == 'active')?" types__item_selected":"")}><Link to="/type/active"></Link></li>
                        <li className={"types__item types__item_menu types__item_discovery" + ((type == 'discovery')?" types__item_selected":"")}><Link to="/type/discovery"></Link></li>
                        <li className={"types__item types__item_menu types__item_pure" + ((type == 'pure')?" types__item_selected":"")}><Link to="/type/pure"></Link></li>
                        <li className={"types__item types__item_menu types__item_cruise" + ((type == 'cruise')?" types__item_selected":"")}><Link to="/type/cruise"></Link></li>
                        <li className={"types__item types__item_menu types__item_expedition" + ((type == 'expedition')?" types__item_selected":"")}><Link to="/type/expedition"></Link></li>
                    </ul>
                </div>


                <h1>{type}nature<span className="types__star">*</span></h1>
                <div className="types__text">
                    <Translate slug={"tour-type__description_" + type} />
                    <div className="types__title"><Translate slug={"tour-type__if"} /> </div>
                    <div className="types__if">
                        <Translate slug={"tour-type__if_" + type} />
                    </div>
                    {type != 'your' &&
                        <Link to="/tours" query={{type: type}} className="types__button">
                            <Translate slug={"tour-type__more"} /> <span className="types__button_uppercase">{type}nature</span>
                        </Link>
                    }
                    {type == 'your' &&
                        <Link to="/custom-tour" className="types__button">
                            <Translate slug={"tour-type__more__your"} />
                        </Link>
                    }
                    <div className="types__comment">
                        <Translate slug={"tour-type__comment_" + type} />
                    </div>
                </div>
            </div>
        );
    }
}



function mapStateToProps(state) {

    return {
        landmark: state.tours.landmark,
        seo: state.user.seo,
        translations: state.user.translations
    };
}


function mapDispatchToProps (dispatch) {
    return {
        toursActions: bindActionCreators(toursActions, dispatch)
    }
}





export default connect(mapStateToProps, mapDispatchToProps)(TypeContent)





// WEBPACK FOOTER //
// ./src/common/components/type/TypeContent.js